<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 承包商人员退厂
-->
<template>
  <div class="h-full">
    <PersonnelLeaveDetail
      ref="personnelLeaveDetail"
      @back="handleBack"
      @save="refreshList"
      v-if="isDetail"
      :taskId="taskId"
      :rowId="rowId"
      :flowTaskId="flowTaskId"
      :accountId="accountId"
      :orgId="orgId"
      :isSelectUser="isSelectUser"
      :flowName="flowName"
      nodeName="结束节点"
    ></PersonnelLeaveDetail>
    <div class="h-full flex" v-if="!isDetail">
      <div class="h-full w-300px flex-shrink-0">
        <el-card class="h-full">
          <div class="mb-10px flex items-center text-14px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">单位目录树</span>
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
                <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="flex mb-10px">
            <el-input
              size="small"
              placeholder="请输入搜索内容"
              v-model="treeKeyword"
              class="mr-10px flex-1"
              clearable
              @keyup.enter.native="searchTreeData"
            ></el-input>
            <el-button type="primary" class="!h-36px" size="mini" @click="searchTreeData"
              >搜索</el-button
            >
          </div>
          <div class="tree overflow-y-auto">
            <el-tree
              v-if="treeStandBy"
              :default-expand-all="defaultExpandAll"
              v-loading="treeLoading"
              highlight-current
              :data="treeData"
              @node-click="handleDocNodeClick"
              :filter-node-method="filterTreeNode"
              :expand-on-click-node="false"
              :props="defaultTreeProps"
              node-key="id"
              ref="tree"
              :default-expanded-keys="defaultExpandIds"
              @node-expand="nodeExpand"
              @node-collapse="nodeCollapse"
            >
              <div slot-scope="{ node, data }" class="node-item">
                <div class="custom-tree-node">
                  <p :title="node.label" class="text-overflow truncate">
                    {{ node.label }}
                  </p>
                  <div>
                    <span class="text-red-500 ml-5px" v-if="data.status === 2">
                      {{ `[${wordPerson(data.status + '')}]` }}</span
                    >
                    <span class="text-red-500 ml-5px" v-if="data.isBlock"> [黑名单]</span>
                  </div>
                </div>
              </div>
            </el-tree>
          </div>
        </el-card>
      </div>
      <div class="h-full rightCol flex-auto w-0px ml-10px">
        <el-card class="h-full" :body-style="{ padding: '20px !important' }" v-loading="loading">
          <div class="flex mb-20px">
            <el-input
              size="small"
              v-model="searchData.nameOrContact"
              clearable
              placeholder="姓名、联系人电话"
              class="!w-50 !mr-10px"
            />
            <!-- <el-input
              size="small"
              v-model="searchData.lable"
              clearable
              placeholder="有无人员定位标签"
              class="!w-200px !mr-10px"
            /> -->
            <el-select
              v-model="searchData.status"
              class="!w-50 !mr-10px"
              size="small"
              placeholder="人员状态"
              filterable
              clearable
            >
              <el-option
                v-for="item in processState"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="searchData.isBlock"
              size="small"
              class="mr-10px !w-54"
              placeholder="请选择是否黑名单"
              clearable
            >
              <el-option
                v-for="item in blackList"
                :key="item.code"
                :label="item.displayName"
                :value="item.code"
              ></el-option>
            </el-select>
            <!-- <el-select
              v-model="searchData.exitWorkflowStatus"
              size="mini"
              placeholder="流程状态"
              class="!w-50 mr-10px"
              clearable
            >
              <el-option
                v-for="item in categoryProcess"
                :key="item.code"
                :label="item.displayName"
                :value="item.code"
              ></el-option>
            </el-select> -->
            <el-button type="primary" class="mr-10px" size="small" @click="handleSearch"
              >搜索</el-button
            >
            <el-button size="small" @click="resetSearch">重置</el-button>
          </div>
          <el-table :data="tableData" height="calc(100% - 110px)" border stripe>
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column
              width="100"
              label="姓名"
              prop="name"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              width="200"
              label="联系电话"
              prop="phoneNumber"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column width="100" label="年龄" prop="age"></el-table-column>
            <el-table-column
              width="200"
              label="是否特种作业人员"
              prop="isWork"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.isSpecialOperationCertificatePersonnel ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column label="工种" prop="jobs" width="100">
              <template slot-scope="scope">
                <span>{{ jobsMap(scope.row.jobs) }}</span>
              </template>
            </el-table-column>
            <el-table-column width="180" label="退厂时间" prop="exitFactoryTime">
              <template slot-scope="scope">
                {{
                  scope.row.exitFactoryTime
                    ? dayjs(scope.row.exitFactoryTime).format('YYYY-MM-DD HH:mm:ss')
                    : ''
                }}
              </template>
            </el-table-column>
            <el-table-column label="退厂原因" prop="exitReason" show-overflow-tooltip width="120">
            </el-table-column>
            <el-table-column width="100" label="是否黑名单" prop="isBlock">
              <template slot-scope="scope">
                <el-tag size="mini" type="danger" v-if="scope.row.isBlock === true">是</el-tag>
                <el-tag size="mini" type="success" v-else-if="scope.row.isBlock === false"
                  >否</el-tag
                >
                <span v-else></span>
              </template>
            </el-table-column>
            <el-table-column width="100" label="人员状态" prop="status">
              <template slot-scope="scope">
                <el-tag size="mini" :type="unitStatusTypes(scope.row.status)">{{
                  wordPerson(scope.row.status + '')
                }}</el-tag>
              </template>
            </el-table-column>
            <!-- 人员退厂用退厂流程状态 -->
            <!-- <el-table-column label="流程状态" prop="exitWorkflowStatus" width="100">
              <template slot-scope="scope">
                <el-tag
                  size="mini"
                  v-if="scope.row.exitWorkflowStatus !== 0"
                  :type="workFlowStatusTypes(scope.row.exitWorkflowStatus)"
                  >{{ workFlowStatusMap(scope.row.exitWorkflowStatus) }}</el-tag
                >
                <span v-else></span>
              </template>
            </el-table-column> -->
            <el-table-column label="操作" fixed="right" width="320">
              <template slot-scope="scope">
                <table-operate-button :key="scope.row.id" :buttons="buttons(scope.row)" />
              </template>
            </el-table-column>
          </el-table>
          <div class="flex justify-end mt-20px">
            <el-pagination
              background
              @size-change="handleSearch"
              @current-change="findList"
              :current-page.sync="pageNo"
              layout="total, sizes, prev, pager, next, jumper"
              :page-size.sync="pageSize"
              :total="total"
              :page-sizes="[15, 30, 45, 60, 75, 90]"
            >
            </el-pagination>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 人员退厂 -->
    <el-dialog
      :close-on-click-modal="false"
      title="人员退厂"
      :visible.sync="leaveDialog"
      width="718px"
      v-dialogDrag
      class="small-dialog"
    >
      <el-form :model="leaveForm" ref="leaveForm" label-width="150px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="leaveForm.name" size="small" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="退厂原因"
          prop="exitReason"
          :rules="[
            {
              required: true,
              message: '请输入退厂原因',
              trigger: 'change',
            },
          ]"
        >
          <el-input
            placeholder="请输入退厂原因"
            type="textarea"
            show-word-limit
            :rows="4"
            maxlength="500"
            v-model="leaveForm.exitReason"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="退厂时间"
          prop="exitFactoryTime"
          :rules="[
            {
              required: true,
              message: '请选择退厂时间',
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            size="small"
            v-model="leaveForm.exitFactoryTime"
            type="datetime"
            disabled
            placeholder="请选择退厂时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button
          size="small"
          type="primary"
          icon="iconfont icon-save"
          @click="saveLeaveForm"
          :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" icon="iconfont icon-close" @click="leaveDialog = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- 出入厂记录 -->
    <el-dialog
      :close-on-click-modal="false"
      title="人员退厂"
      :visible.sync="tableDialog"
      width="1280px"
      v-dialogDrag
      top="2vh"
      class="large-dialog"
    >
      <el-table :data="tableDialogData" :height="tableHeight" border stripe class="mb-15px">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column label="姓名" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="联系电话"
          prop="phoneNumber"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="年龄" prop="age"></el-table-column>
        <el-table-column label="是否特种作业人员" prop="isWork" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.isSpecialOperationCertificatePersonnel ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="工种" prop="jobs" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ wordJob(scope.row.jobs + '') }}
          </template>
        </el-table-column>
        <el-table-column label="入厂时间" prop="enterFactoryTime" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              scope.row.enterFactoryTime
                ? dayjs(scope.row.enterFactoryTime).format('YYYY-MM-DD HH:mm:ss')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="退厂时间" prop="exitFactoryTime" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              scope.row.exitFactoryTime
                ? dayjs(scope.row.exitFactoryTime).format('YYYY-MM-DD HH:mm:ss')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="退厂原因" prop="exitReason" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <!-- <div class="flex justify-center">
        <el-button size="small" icon="iconfont icon-close" @click="tableDialog = false"
          >取消</el-button
        >
      </div> -->
    </el-dialog>

    <!-- 流程弹窗 -->
    <ApprovalFlowDialog
      :visible.sync="approvalFlowDialog"
      v-if="approvalFlowDialog"
      :id="flowTaskId"
      @cancel="approvalFlowDialog = false"
    >
    </ApprovalFlowDialog>

    <!-- 选择人员弹窗start -->
    <SelectDeptUser
      v-if="showUserDialog"
      :visible.sync="showUserDialog"
      :flowName="flowName"
      :flowWorkName="'承包商人员退厂审批'"
      nodeName="审批节点"
      @selectSuccess="selectSuccess"
    ></SelectDeptUser>
    <!-- 选择人员弹窗end -->
  </div>
</template>

<script type="text/babel">
import dayjs from 'dayjs'
import qs from 'qs'
import {
  ContractorApi,
  ContractorPersonnelApi,
  ContractorPersonnelAccessRecordApi,
  ContractorAccountRelationApi,
} from '@wiz-api/contractor-management'
import { ViolationRecordApi } from '@wiz-api/personnel-safety-management'
import utils from '@/components/safety/enumField/utils'

import { unitStatusTypes, workFlowStatusTypes } from '@/components/safety/enumField/enumTypeMethods'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import ApprovalFlowDialog from '@/components/safety/ApprovalFlow/ApprovalFlowDialog'
import PersonnelLeaveDetail from '../components/PersonnelLeaveDetail'
import SelectDeptUser from '../components/SelectDeptUser'

const contractorAccountRelationApi = new ContractorAccountRelationApi()
const contractorApi = new ContractorApi()
const contractorPersonnelApi = new ContractorPersonnelApi()
const contractorPersonnelAccessRecordApi = new ContractorPersonnelAccessRecordApi()
const violationRecordApi = new ViolationRecordApi()
export default {
  name: 'contractor-personnel-leave',
  components: {
    PersonnelLeaveDetail,
    TableOperateButton,
    ApprovalFlowDialog,
    SelectDeptUser,
  },
  data() {
    return {
      flowName: '承包商人员退厂审批', // 流程名称
      showUserDialog: false, // 是否显示选择人员弹窗
      isSelectUser: false, // 是否有人员选择功能
      blackList: [
        { code: true, displayName: '是' },
        { code: false, displayName: '否' },
      ],
      // 用于审批
      taskId: null,
      approvalFlowDialog: false,
      // 用于查看流程
      flowTaskId: null,
      rowId: null,
      defaultExpandAll: false,
      treeStandBy: true, // 是否显目录树 用于刷新树
      leaveDialog: false,
      isDetail: false,
      fileList: [],
      currentEnv: null,
      saveLoading: false,
      currentTreeData: null,
      currentTreeSelect: null,
      pageNo: 1,
      pageSize: 15,
      total: 0,
      treeHandleType: '',
      leaveForm: {
        name: '',
        exitReason: '',
        exitFactoryTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      },

      tableDialog: false,
      tableDialogData: [],

      deviceHandleType: '',
      treeKeyword: '',
      treeLoading: false,
      defaultTreeProps: {
        children: 'children',
        label: 'orgName',
      },
      // 原数据
      originTree: [],
      treeData: [
        {
          orgName: '承包商',
          id: '',
          isCompany: true,
          children: [],
        },
      ],
      defaultExpandIds: [],
      keyword: '',
      tableData: [],
      selectKey: 63635,
      loading: false,
      categoryProcess: [],
      processState: [],
      personJob: [],
      searchData: {
        isBlock: undefined,
        status: '',
        // isSpecialOperationCertificatePersonnel: '',
        isArchives: '',
        exitWorkflowStatus: null,
      },
      contractorId: '',
      accountId: '',
      orgId: '',
    }
  },
  beforeUpdate() {
    this.categoryProcess = this.categoryProcess.filter((item) => {
      return item.code != 0
    })
  },
  async created() {
    if (this.$route.query.id && this.$route.query.taskId && this.$route.query.mode) {
      this.handleDetail(
        { id: this.$route.query.id, exitFlowTaskId: this.$route.query.taskId },
        this.$route.query.mode === 'approve' ? 'approve' : ''
      )
    }
    utils.getDataCategory(
      [
        'ContractorManagement.DataCategory.WorkflowStatus',
        'ContractorManagement.DataCategory.IncomingfactoryStatus',
        'ContractorManagement.DataCategory.Jobs',
      ],
      ['categoryProcess', 'processState', 'personJob'],
      this
    )

    this.getTreeData()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 15px)'
    },
    workFlowStatusTypes() {
      return (val) => {
        return workFlowStatusTypes(val)
      }
    },
    workFlowStatusMap() {
      return (val) => {
        return (
          this.categoryProcess.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    jobsMap() {
      return (val) => {
        return (
          this.personJob.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    tableFormDisabled() {
      return this.deviceHandleType === 'detail'
    },
    unitStatusTypes() {
      return (val) => {
        return unitStatusTypes(val)
      }
    },
    wordPerson() {
      return (value) => {
        return (
          this.processState.find((item) => {
            return item.code === value
          })?.displayName || ''
        )
      }
    },
    wordProcess() {
      return (value) => {
        return (
          this.categoryProcess.find((item) => {
            return item.code === value
          })?.displayName || ''
        )
      }
    },
    wordJob() {
      return (value) => {
        return (
          this.personJob.find((item) => {
            return item.code === value
          })?.displayName || ''
        )
      }
    },
    buttons() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleDetail(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '退厂',
            click: () => {
              return this.handleLeave(val)
            },
            // 显示按钮：单位状态在厂，流程状态不为审核中，且不为黑名单
            isShow:
              this.$hasAccess('leave') &&
              ['0', '1'].indexOf(`${val.status}`) > -1 &&
              val.exitWorkflowStatus !== 1 &&
              !val.isBlock,
          },
          {
            text: '出入厂记录',
            click: () => {
              return this.viewLeaveRecord(val)
            },
            isShow: this.$hasAccess('history'),
          },
          // {
          //   text: '审批',
          //   click: () => {
          //     return this.handleDetail(val, 'approve')
          //   },
          //   // 审批code为001，且单位退厂状态为审核中
          //   isShow:
          //     this.$hasAccess('audit') && val.exitWorkflowStatus === 1 && val.oprateCode === '001',
          // },
          // {
          //   text: '查看流程',
          //   click: () => {
          //     return this.viewProcess(val)
          //   },
          //   isShow: this.$hasAccess('flow') && val.exitFlowTaskId,
          // },
        ]
      }
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  methods: {
    // 返回上一页
    async handleBack() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.isDetail = false
    },
    // 刷新列表
    async refreshList() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.isDetail = false
      this.handleSearch()
    },
    async getContractorInfo() {
      // 拿承包商id和模板id
      const [err, res] = await contractorAccountRelationApi.getContractorAccountRelationByUserDto()
      if (!err) {
        this.contractorId = res.contractorId
      }
    },
    operateTree(bool) {
      this.defaultExpandIds = this.$options.data().defaultExpandIds
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    async saveLeaveForm() {
      this.$refs.leaveForm.validate(async (valid) => {
        if (valid) {
          // this.showUserDialog = true
          this.saveLoading = true
          this.leaveForm.exitFactoryTime = this.leaveForm.exitFactoryTime
            ? dayjs(this.leaveForm.exitFactoryTime).format('YYYY-MM-DD HH:mm:ss')
            : undefined
          const [err, res] = await contractorPersonnelApi.exitSubmit({
            body: {
              ...this.leaveForm,
              // receiverIds: userIds,
            },
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            })
            this.leaveDialog = false
            this.findList()
          }
          this.saveLoading = false
        }
      })
    },

    /**
     * @description 选择人员完成
     * @param {Array} userIds 人员id
     */
    async selectSuccess(userIds) {
      this.saveLoading = true
      this.leaveForm.exitFactoryTime = this.leaveForm.exitFactoryTime
        ? dayjs(this.leaveForm.exitFactoryTime).format('YYYY-MM-DD HH:mm:ss')
        : undefined
      const [err, res] = await contractorPersonnelApi.exitSubmit({
        body: {
          ...this.leaveForm,
          receiverIds: userIds,
        },
      })
      if (!err) {
        this.$message({
          showClose: true,
          message: '操作成功',
          type: 'success',
        })
        this.leaveDialog = false
        this.findList()
      }
      this.saveLoading = false
    },

    async getViolationInfo(row) {
      const params = {
        maxResultCount: this.pageSize,
        skipCount: (this.pageNo - 1) * this.pageSize,
        sorting: 'CreationTime DESC',
        personnelId: row.accountId,
      }
      if (params._date) {
        params._date = new Date(params._date)
      }
      const [err, res] = await violationRecordApi.violationArchives(params)
      if (err || !res.items.length) {
        sessionStorage.setItem(
          'CURRENT_VIOLATION_PEOPLE',
          JSON.stringify({
            personnelName: row.name,
            unitName: row.contractorName,
            totalScore: null,
            punishCount: 0,
            penaltyScore: 0,
            penaltyAmount: 0,
            trainHour: 0,
            rewardCount: 0,
            rewardScore: 0,
            rewardAmount: 0,
          })
        )
      } else {
        sessionStorage.setItem('CURRENT_VIOLATION_PEOPLE', JSON.stringify(res.items[0]))
      }
    },
    handleDetail(row, editType) {
      this.getViolationInfo(row)
      this.isSelectUser = row.exitWorkflowStatus === 1
      this.isDetail = true
      // 用于审批
      this.taskId = this.$route.query.taskId ? this.$route.query.taskId : row.taskId
      this.rowId = this.$route.query.id ? this.$route.query.id : row.id
      // 人员idaccountId
      this.accountId = this.$route.query.accountId ? this.$route.query.accountId : row.accountId
      this.orgId = this.$route.query.orgId ? this.$route.query.orgId : row.orgId

      // 用于查看流程
      this.flowTaskId = row.exitFlowTaskId || ''
      this.$nextTick(() => {
        this.$refs.personnelLeaveDetail.handleDetail(row, editType)
      })
    },
    handleForm() {
      this.isDetail = true
    },
    handleLeave(row) {
      this.leaveForm = this.$options.data().leaveForm
      this.leaveForm.personnelId = row.id
      this.leaveForm.name = row.name
      this.leaveForm.taskId = row.taskId
      this.leaveDialog = true
      this.$nextTick(() => {
        this.$refs.leaveForm.clearValidate()
      })
    },
    async viewLeaveRecord(row) {
      const [err, res] = await contractorPersonnelAccessRecordApi.getPageList({
        personnelId: row.id,
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.tableDialogData = res.items
        this.tableDialog = true
      }
    },
    viewProcess(row) {
      this.flowTaskId = row.exitFlowTaskId
      if (typeof this.flowTaskId === 'string' && _.includes(this.flowTaskId, '-')) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.flowTaskId)
      } else {
        this.approvalFlowDialog = true
      }
    },
    async getTreeData() {
      this.getContractorInfo()
      this.treeLoading = true
      const [err, res] = await contractorApi.contractorNamesDto()
      if (!err) {
        this.treeData[0].children = res
        // 初始化选中第一个单位
        this.currentTreeSelect = this.treeData[0]
        this.defaultExpandIds = [this.treeData[0]?.id]
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.treeData[0]?.id)
        })
        this.findList()
      }
      this.treeLoading = false
      // this.treeData = this.JSONToTree(list.reverse())
    },
    filterTreeNode(value, data) {
      if (!value) {
        return true
      }
      return data.name.indexOf(value) !== -1
    },
    searchTreeData() {
      this.$refs.tree.filter(this.treeKeyword)
    },
    // 节点展开
    nodeExpand(data) {
      this.defaultExpandIds.push(data.id)
    },
    // 节点关闭
    nodeCollapse(data) {
      this.defaultExpandIds = _.difference(this.defaultExpandIds, [data.id])
    },
    handleDocNodeClick(data) {
      this.currentTreeSelect = data
      this.handleSearch()
    },
    handleSearch() {
      this.pageNo = 1
      this.findList()
    },
    resetSearch() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 数组转化成树结构
    JSONToTree(data, parent = null, pid = 'parentId') {
      const tree = []
      let temp = []
      // eslint-disable-next-line no-restricted-syntax
      for (const i of data) {
        if (i[pid] === parent) {
          const obj = i
          temp = this.JSONToTree(data, i.id, pid)
          if (temp.length > 0) {
            obj.children = temp
          }
          tree.push(obj)
        }
      }
      return tree
    },
    async findList() {
      this.loading = true
      if (window.__POWERED_BY_QIANKUN__) {
        // 低代码
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res = await instance.get(
          `/api/contractor-management/contractor-personnels/exit-page-list?${qs.stringify({
            contractorId: this.currentTreeSelect.id || this.contractorId,
            skipCount: (this.pageNo - 1) * this.pageSize,
            maxResultCount: this.pageSize,
            ...this.searchData,
          })}`
        )
        if (res.status === 200 && res.data) {
          this.tableData = res.data.items
          this.total = res.data.totalCount
        }
        this.loading = false
        return
      }
      const [err, res] = await contractorPersonnelApi.getExitPageList({
        contractorId: this.currentTreeSelect.id || this.contractorId,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...this.searchData,
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
.tree {
  height: calc(100% - 74px);

  ::v-deep .el-tree-node__content {
    height: 35px;

    .node-item {
      width: calc(100% - 24px);

      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}

.button-normal.el-button.el-tooltip {
  padding: 6px 12px !important;
  width: unset !important;
  height: unset !important;
}

::v-deep .el-select__tags .el-tag {
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}

::v-deep .el-card__body {
  height: 100%;
}
</style>
